export const toPluralForm = (noun: string, count = 2): string => (count === 1 ? noun : `${noun}s`);

export const getItemsCountLabel = (noun: string, count: number): string => {
  const countAwareNoun = count === 1 ? noun : toPluralForm(noun);
  return `${count} ${countAwareNoun}`;
};
